module.exports = __webpack_public_path__ + "img/Monster.fc89f1bf.jpg";